import React from "react";
// import "./Loading.css"; // Optional: if you want to add some styles
import ClipLoader from "react-spinners/ClipLoader";

const Loading = () => {
  return (
    <div>
      <ClipLoader
        loading={true}
        size={100}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
};

export default Loading;
